module.exports = __webpack_public_path__ + "b3861e751950f77998630dc6fcc7d9e3.svg";